export default __webpack_public_path__ + "static/media/willInfoImg.d358b489.svg";